export function normalizeString(str) {
    return str
        .normalize('NFD') // tách dấu ra
        .replace(/[\u0300-\u036f]/g, '') // loại bỏ dấu
        .replace(/đ/g, 'd') // thay đ thành d
        .replace(/Đ/g, 'D') // thay Đ thành D
        .toLowerCase();
}
/**
 * Filter function cho Select filterOption, tìm kiếm full-text,
 * không phân biệt hoa thường, bỏ dấu tiếng Việt.
 * @param input Chuỗi người dùng nhập
 * @param option Option của Select (có label)
 * @returns true nếu option phù hợp với input
 */
export function fullTextSearchFilter(input, option) {
    if (!input)
        return true;
    const normalizedInput = normalizeString(input);
    const normalizedLabel = normalizeString(option?.label?.toString() ?? '');
    // Tách input và label theo cùng 1 pattern
    const inputWords = normalizedInput.split(/[\s\-/]+/).filter(Boolean);
    const labelWords = normalizedLabel.split(/[\s\-/]+/).filter(Boolean);
    return inputWords.every((inputWord) => labelWords.some((labelWord) => labelWord.includes(inputWord)));
}
/**
 * Filter function: bỏ dấu, không phân biệt hoa thường,
 * chỉ cần label chứa input (substring).
 */
export function simpleSearchFilter(input, option) {
    if (!input)
        return true;
    const normalizedInput = normalizeString(String(input)).trim();
    const normalizedLabel = normalizeString(String(option?.label ?? '')).trim();
    return normalizedLabel.includes(normalizedInput);
}
